export default __webpack_public_path__ + "static/media/announcement_5_lyte.19a8739c.png";